import _ from 'lodash';
import globalStore from '$$globalStore';
import constants from '$$helpers/constants';

export default async (resourceIds, ganttIds, action) => {
  const tasksToUpdate = [];
  let sourceEvent;

  if (action === 'removeResources') {
    sourceEvent = {
      type: constants.GANTT_SOURCE_EVENT_TYPES.RESOURCE_REMOVE,
    };
  }

  if (action === 'removeResourcesFromProjects') {
    sourceEvent = {
      type: constants.GANTT_SOURCE_EVENT_TYPES.RESOURCE_FROM_PROJECT_UNASSIGN,
    };
  }

  if (action === 'changeResourcesTypeOnProjects') {
    sourceEvent = {
      type: constants.GANTT_SOURCE_EVENT_TYPES.RESOURCE_TYPE_UPDATE,
    };
  }

  if (!sourceEvent) {
    throw new Error('Event type is not provided');
  }

  _.uniq(ganttIds).forEach(ganttId => {
    resourceIds.forEach(resourceId => {
      const tasks = globalStore.getters['tasksModel/getTasksByResourceIdAndGanttIds'](+resourceId, [+ganttId]).map(t => t.taskData);

      tasks.forEach(task => {
        const changedResources = [];

        switch (sourceEvent.type) {
        case constants.GANTT_SOURCE_EVENT_TYPES.RESOURCE_REMOVE:
          changedResources.push({ resource_id: +resourceId, action: 'delete' });
          break;
        case constants.GANTT_SOURCE_EVENT_TYPES.RESOURCE_FROM_PROJECT_UNASSIGN:
          changedResources.push({ resource_id: +resourceId, action: 'delete' });
          break;
        case constants.GANTT_SOURCE_EVENT_TYPES.RESOURCE_TYPE_UPDATE:
          changedResources.push({ resource_id: +resourceId, value: 0, action: 'update' }); // todo: remove customEstimation?
          break;
        }

        tasksToUpdate.push({
          id: task.id,
          changedResources,
        });
      });
    });
  });

  if (tasksToUpdate.length) {
    await globalStore.dispatch('tasksModel/updateTasks', {
      tasks: tasksToUpdate,
      sourceEvent,
      fromGantt: false,
    });
  }
};
